import { createContext, Dispatch, FC, useCallback, useContext, useReducer } from 'react';
import { reducer } from './reducer';
import { ClaimPropertiesActions, ClaimPropertiesActionTypes, ClaimPropertiesKey } from './actions';
import generateKey from 'utils/generateKey';

export const initialState = { key: generateKey(), dispatch: () => null };
export interface PrincipalMemberProps {
  memberType: string;
  given_name: string;
  family_name: string;
  name: string;
  firstLogin?: string;
  preferred_username?: string;
  ilClientKey?: string;
  ebClientKey?: string;
}

type ClaimPropertiesContextProps = ClaimPropertiesKey & {
  dispatch: Dispatch<ClaimPropertiesActions>;
};

const ClaimPropertiesContext = createContext<ClaimPropertiesContextProps>(initialState);

export function useClaimPropertiesContext() {
  const { key, dispatch } = useContext(ClaimPropertiesContext);

  const refreshKey = useCallback(
    () =>
      dispatch({
        type: ClaimPropertiesActionTypes.REFRESH,
        payload: { key: generateKey() },
      }),
    [dispatch],
  );

  return {
    key,
    refreshKey,
  };
}

const ClaimPropertiesContextProvider: FC = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return <ClaimPropertiesContext.Provider value={{ ...state, dispatch }}>{children}</ClaimPropertiesContext.Provider>;
};

export default ClaimPropertiesContextProvider;
